import {dateTime} from "services/date";
import {Exhibit} from "types/Exhibit";
import {deserialize as deserializeFile} from "services/ngage/files";
import deserializeNote from "services/ngage/deserializers/note";
import deserializeElement from "services/ngage/deserializers/element";

/**
 * Transform the given exhibit by deserializing object properties
 *
 * @internal
 * @param exhibit
 */
export default function deserializeExhibit(exhibit: any): Exhibit {
    exhibit.hidden_at = dateTime(exhibit.hidden_at)
    exhibit.published_at = dateTime(exhibit.published_at)
    exhibit.created_at = dateTime(exhibit.created_at)
    exhibit.updated_at = dateTime(exhibit.updated_at)

    if (exhibit.media) {
        exhibit.media = exhibit.media.map(deserializeFile)
    }

    if(exhibit.notes) {
        exhibit.notes = exhibit.notes.map(deserializeNote)
    }

    if(exhibit.elements) {
        exhibit.elements = exhibit.elements.map(deserializeElement)
    }

    return exhibit;
}